import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Card, CardContent } from '../components/ui/Card';
import { SEO } from '../utils/seo';
export function NewsPage() {
  const articles = [{
    id: 'kafaa',
    title: 'Tourisme : le programme "Kafaa" vise à certifier 7.550 professionnels d\'ici 2026 (Mme Ammor)',
    excerpt: 'Rabat - Le programme "Kafaa" de validation des acquis de l\'expérience (VAE) a pour objectif de certifier 7.550 professionnels...',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=2076&auto=format&fit=crop'
  }, {
    id: 'maroc-destination',
    title: 'Le Maroc se consolide comme « une destination leader du tourisme mondial », selon une revue argentine',
    excerpt: 'Buenos Aires - Le Maroc se positionne comme « une destination leader du tourisme mondial » après avoir battu le record...',
    image: 'https://images.unsplash.com/photo-1489749798305-4fea3ae63d43?q=80&w=2067&auto=format&fit=crop'
  }, {
    id: 'tourisme-inclusif',
    title: 'Le tourisme inclusif, un élément clé pour le développement de toutes les régions du Maroc (Mme Ammor)',
    excerpt: 'Casablanca - Le tourisme inclusif constitue un "élément clé" pour le développement et l\'intégration de toutes les régions marocaines...',
    image: 'https://images.unsplash.com/photo-1511632765486-a01980e01a18?q=80&w=2070&auto=format&fit=crop'
  }, {
    id: 'ryanair',
    title: 'ONMT/Ryanair: Lancement à partir de janvier prochain de deux lignes aériennes directes reliant Dakhla à Madrid et Lanzarote',
    excerpt: "Dakhla - L'Office National Marocain du Tourisme (ONMT) et la compagnie aérienne Ryanair ont signé, mercredi...",
    image: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?q=80&w=2074&auto=format&fit=crop'
  }, {
    id: 'wtm-londres',
    title: 'Tourisme : Le Maroc sacré "destination la plus accueillante" au WTM de Londres',
    excerpt: 'Londres - L\'Office national marocain du tourisme (ONMT) a reçu, mardi soir, le prix de la "Destination la plus accueillante"...',
    image: 'https://images.unsplash.com/photo-1569025690938-a00729c9e1f9?q=80&w=2070&auto=format&fit=crop'
  }, {
    id: 'royal-air-maroc',
    title: 'Aéroport Mohammed V de Casablanca : Royal Air Maroc réceptionne son dixième Boeing 787-9 Dreamliner',
    excerpt: "Casablanca - Royal Air Maroc (RAM) annonce avoir réceptionné, dimanche à l'aéroport Mohammed V de Casablanca, son dixième...",
    image: 'https://images.unsplash.com/photo-1464037866556-6812c9d1c72e?q=80&w=2070&auto=format&fit=crop'
  }];
  return <div className="min-h-screen bg-white" data-id="element-531">
      <SEO title="Actualités" description="Suivez les actualités du tourisme et de l'hôtellerie au Maroc - Programme Kafaa, développement touristique, initiatives ONMT et tendances du secteur" keywords="actualités tourisme Maroc, news hôtellerie Agadir, ONMT, programme Kafaa, tourisme Maroc" ogImage="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=2076&auto=format&fit=crop" data-id="element-532" />
      <Navbar data-id="element-533" />

      {/* Hero */}
      <section className="bg-arih-blue py-24 md:py-32" data-id="element-534">
        <div className="container mx-auto px-4 md:px-8 text-center" data-id="element-535">
          <h1 className="text-[48px] md:text-[70px] font-semibold text-white leading-tight mb-6" data-id="element-536">
            Actualités
          </h1>
          <p className="text-[20px] text-white/90 leading-[32px] max-w-2xl mx-auto" data-id="element-537">
            Suivez les actualités nationales du secteur : événements,
            initiatives, tendances et évolutions qui impactent l'industrie.
          </p>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="bg-arih-light-bg py-[120px]" data-id="element-538">
        <div className="container mx-auto px-4 md:px-8" data-id="element-539">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-540">
            {articles.map(article => <Card key={article.id} className="bg-white rounded-xl shadow-sm overflow-hidden border-0" data-id="element-541">
                <CardContent className="p-0" data-id="element-542">
                  <img src={article.image} alt={article.title} className="w-full h-[260px] object-cover" data-id="element-543" />
                  <div className="p-6" data-id="element-544">
                    <h3 className="text-[20px] font-bold text-arih-dark leading-tight mb-3" data-id="element-545">
                      {article.title}
                    </h3>
                    <p className="text-[18px] text-arih-gray leading-[28.8px] mb-4 line-clamp-2" data-id="element-546">
                      {article.excerpt}
                    </p>
                    <a href={`/news/${article.id}`} className="text-arih-blue text-[16px] font-semibold hover:underline inline-flex items-center" data-id="element-547">
                      Voir plus <span className="ml-1" data-id="element-548">→</span>
                    </a>
                  </div>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </section>

      <Footer data-id="element-549" />
    </div>;
}